var printFlag = false;
var pageTitle = document.title;

function beforePrint() {
	printFlag = true;
}

function afterPrint() {
	printFlag = false;
}

if (window.matchMedia) {
	window.matchMedia('print').addListener(function (mql) {
		if (mql.matches) {
			beforePrint();
		} else {
			afterPrint();
		}
	});
}
window.onbeforeprint = beforePrint;
window.onafterprint = afterPrint;

$(document).ready(function () {

	Gifffer();

	$(window).on('resize', aside_sticky_menu);
	aside_sticky_menu();
	$('#step12 .tags_in .tag').on('click', tags_animate);

	if ($('#step12').length) {
		window.allow_scroll = false;
		window.setTimeout(function () {
			if (window.scrolldef) {
				var $target = $('[name=' + window.scrolldef + ']');
				if ($target.length) $(window).scrollTop($target.offset().top - 90); else $(window).scrollTop(0);
			} else {
				$(window).scrollTop(0);
			}
			window.setTimeout(function () {
				$('body').removeClass('guide_start');
			}, 100);
			window.allow_scroll = true;
			$(window).trigger('scroll');
		}, 100);
		$('#blog_right nav a').on('click', function (evt) {

			var $target = $('[name=' + $(this).attr('rel') + ']');
			$('#bb' + $(this).parent().attr('rel')).css({minHeight: 500});

			if (window.innerWidth <= 800) {

				var g = this.rel || false;
				tb_show(this.innerText, this.href + '/popup', g, evt);
				Gifffer();
				this.blur();
				return false;

			} else if ($target.length) {

				var targetOffset = $target.parent().offset().top - 70;
				window.allow_scroll = false;
				$('body').addClass('do_scrolling');
				$('html,body').animate({scrollTop: targetOffset}, 1000, function () {
					window.allow_scroll = true;
					$(window).trigger('scroll');
					$('body').removeClass('do_scrolling');
				});

				return false;

			}

			return true;

		});

	}
});

$(window).on('resize scroll', function () {
	if (printFlag) return;

	if ($('#step12').length && $('#blog').is(':visible')) {
		if (window.allow_scroll) {
			var cur_item = null;
			$('#blog .item:visible').each(function () {
				if ($(window).scrollTop() >= $(this).offset().top - 150) cur_item = this;
			});
			$('#blog_list .item').removeClass('item_act');
			if (!cur_item) cur_item = $('#blog .item:visible').get(0);
			var target = $('#ba' + $(cur_item).attr('rel'));
			target.addClass('item_act').find('.bg').css({width: Math.min(340, Math.max(0, Math.round(0 + 340 * ($(window).scrollTop() - $(cur_item).offset().top) / Math.max(100, 60 + $(cur_item).find('.text_').outerHeight() + $(cur_item).find('h2:first').outerHeight() - $(window).height() + 100))))});
			if (!$(cur_item).hasClass('item_act')) {
				$('#blog > .item').removeClass('item_act');
				$(cur_item).addClass('item_act');
				history.replaceState(null, target.find('a').text() + ' - ' + pageTitle, target.find('a').attr('href'));
				document.title = target.find('a').text() + ' - ' + pageTitle;
			}
			step12_load_content();
		}
	}
});

function aside_sticky_menu() {
	var blog_right = $('#blog_right');
	blog_right.removeClass('blog_right_rel');
	if (blog_right.outerHeight() + parseInt(blog_right.css('top')) - 10 >= window.innerHeight) {
		blog_right.addClass('blog_right_rel');
	} else if (blog_right.hasClass('blog_right_rel')) {
		blog_right.removeClass('blog_right_rel');
	}
}

function tags_animate() {

	if ($(this).hasClass('tag_act')) {
		return false;
	}

	$(this).parent('.tags_in').addClass('animate_tags');

	var tag_act = $('.tag_act'),
		tag_not_act = $('.tag:not(.tag_act)');

	$('body.guide nav#blog_list').removeClass('guide guide_user').addClass(tag_not_act.data('type'));
	mainUrl = $('body').attr('rel') + tag_not_act.data('type');
	$('.animate_tags').prepend(`<div id="animate_rec" 
                                style="left: ${tag_act.position().left}px;
                                       width: ${tag_act.outerWidth()}px;"></div>`);
	tag_act.removeClass('tag_act');
	window.allow_scroll = false;
	$('#animate_rec').on('transitionend', function () {
		tag_not_act.addClass('tag_act');
		$('.animate_tags').removeClass('animate_tags');
		$(this).remove();
		history.replaceState(null, tag_not_act.text() + ' - ' + pageTitle, tag_not_act.attr('href'));
		document.title = tag_not_act.text() + ' - ' + pageTitle;
		var $h1 = $('#guide-h1');
		if ($h1.length) { var alt = $h1.data('h1-alt'); $h1.data('h1-alt', $h1.text()); $h1.text(alt); }
		var scrollTime = 0;
		if ($(window).scrollTop() > 500) scrollTime = 1000;
		else if ($(window).scrollTop() > 100) scrollTime = 400;
		$('html,body').animate({scrollTop: 0}, scrollTime, function () {
			$(window).trigger('scroll');
			$('body').removeClass('do_scrolling');
			$.get(tag_not_act.attr('href') + '/list',
				function (data) {
					$('#blog').html(data);
					Gifffer();
					window.allow_scroll = true;
				});
		});
	});

	$('#animate_rec').css({
		left: tag_act.position().left == 0 ? tag_act.outerWidth() + 'px' : 0,
		width: tag_not_act.outerWidth()
	});

	return false;
}

function step12_load_content() {
	if ($('body').hasClass('guide_start')) return;

	var docViewTop = $(window).scrollTop() + 70,
		docViewBottom = docViewTop + $(window).height();

	$('#blog .item_hid.item:visible').each(function () {

		var elemTop = $(this).offset().top,
			elemBottom = elemTop + $(this).outerHeight();

		if ((elemTop > docViewTop && elemTop < docViewBottom)) {
			let cur_item2 = this;
			$(cur_item2).removeClass('item_hid');
			$.get(mainUrl + '/' + $(cur_item2).attr('rel') + '/article',
				function (data) {
					$(cur_item2).find('.text_').replaceWith(data);
					Gifffer();
					$(window).trigger('scroll');
					step12_load_content();
				});

			$('#ba' + $(cur_item2).attr('rel')).removeClass('item_hid');
		}

	});

}